<template>
  <b-rating :border="true" :icons="state_icon" :max="state_rating_max" :score="state_rating_score" v-if="state_rating_score > 0"></b-rating>
</template>

<script>
import Rating from './rating.vue'

export default {
  components: {
    'b-rating': Rating
  },

  computed: {
    state_icon: function() {
      return [this.$assets.state_flags[this.match.state]]
    },

    state_rating_max: function() {
      if(this.match.data.state_rating && this.match.data.state_rating.max) {
        return this.match.data.state_rating.max
      }
      return 0
    },

    state_rating_score: function() {
      if(this.match.data.state_rating && this.match.data.state_rating.score) {
        return this.match.data.state_rating.score
      }
      return 0
    },
  },

  props: ['match']
}
</script>
